import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import InfoBox from '../../../InfoBox'

class NextScheduledPlaylist extends PureComponent {
    static propTypes = {
        name: PropTypes.string,
        isEmpty: PropTypes.bool,
        loading: PropTypes.number,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        name: '',
        isEmpty: true,
        loading: null,
    }

    render() {
        const { name, isEmpty, loading, t } = this.props
        return <InfoBox isEmpty={isEmpty} loading={loading} title={t('Next Scheduled Playlist')} value={name} />
    }
}

export default withTranslation()(NextScheduledPlaylist)
